import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=f88b1b7a&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=f88b1b7a&lang=scss&scoped=true&"
import style1 from "./UserAvatar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88b1b7a",
  null
  
)

export default component.exports